module.exports = __webpack_public_path__ + "media/offers_icons/przyczepy-white-068ad044.svg";